<template>
	<div id="app">
		<router-view></router-view>
		<vue-toast ref='toast'></vue-toast>
		<contact-dialog></contact-dialog>
	</div>
</template>

<script>
	import VueToast from 'vue-toast'
	import ContactDialog from './components/ContactDialog'

	export default {
		components: { 
			VueToast, 
			ContactDialog 
		},
		mounted(){
			const toast = this.$refs.toast
			this.$bus.$on('showToast', (text, theme) => {
				toast.showToast(text, {
					theme: theme || 'default',
					timeLife: 3000,
					closeBtn: false
				})
			});
		}
	}
</script>

<style>
	#app {
		font-family: 'Roboto', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
</style>


// WEBPACK FOOTER //
// App.vue?5ce10c58